const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export class UuidUtil {
	static isUuid(value: string | null | undefined): boolean {
		return typeof value === "string" && UUID_REGEX.test(value);
	}

	static isNotUuid(value: string | null | undefined): boolean {
		return !UuidUtil.isUuid(value);
	}
}
